<template>
    <div class="record-create-success">
        <div class="header">
            <h1>Auftragserfassung</h1>

            <div v-if="record.id" class="record-details">
                <p class="mb-1">
                    <b>Akte:</b> {{ record.attributes.referenceNumber }}
                </p>

                <csp-record-customer-vehicle-info :claim-type="record.attributes.claimType"
                    :claim-type-comprehensive="record.attributes.claimTypeComprehensive"
                    :claim-type-delivery="record.attributes.claimTypeDelivery"
                    :customer-attributes="customer.attributes"
                    :is-first-party-damage="record.attributes.isFirstPartyDamage"
                    :vehicle-attributes="vehicle.attributes"/>
            </div>
        </div>

        <div v-if="record.id" class="success-body text-center">
            <i class="inticon-completed-circle mb-5 text-secondary" style="font-size: 92px;"/>

            <h3>Akte wurde erfolgreich angelegt</h3>

            <div class="success-body-description mt-3">
                <p v-if="!isDebtCollectionClaim">
                    Der Vorgang wurde Ihren Schadenakten hinzugefügt.
                    Sie werden nun automatisch in die
                    <template v-if="isDeliveryClaim">
                        detailliertere Schadensbeschreibung
                    </template>
                    <template v-if="isRegressClaim">
                        Zusammenfassung
                    </template>
                    <template v-else>
                        detailliertere Unfalldokumentation
                    </template>
                    weitergeleitet.
                </p>
                <p v-if="isDebtCollectionClaim">
                    Der Vorgang wurde Ihren Schadenakten hinzugefügt.
                    Sie werden nun automatisch zur weiteren Kundendateneingabe weitergeleitet.
                </p>
            </div>
        </div>

        <div v-if="!record.id" class="d-flex justify-content-center py-3 mb-0">
            <csp-loading-indicator/>
        </div>
    </div>
</template>

<script>
    import Container from '@services/Container';
    import ItemDataSkeletton from '@js/jsonapi/skeletton/ItemDataSkeletton';
    import ClaimTypeEnum from '@js/enums/damage/ClaimTypeEnum';

    const container = Container.getInstance();
    const recordRepository = container.getRecordRepository();

    export default {
        data() {
            return {
                record: new ItemDataSkeletton(),
                accident: new ItemDataSkeletton(),
                customer: new ItemDataSkeletton(),
                vehicle: new ItemDataSkeletton(),
            }
        },
        computed: {
            isDebtCollectionClaim() {
                return this.record.attributes.claimType === ClaimTypeEnum.DEBT_COLLECTION;
            },
            isDeliveryClaim() {
                return this.record.attributes.claimType === ClaimTypeEnum.DELIVERY;
            },
            isRegressClaim() {
                return this.record.attributes.claimType === ClaimTypeEnum.REGRESS;
            },
            toRecordAccidentData() {
                return {
                    name: 'accidentDocumentationRoute',
                    params: {recordId: this.$route.params.recordId},
                    query: {editMode:'accidentDocumentationBasedata'},
                }
            },
            toRecordCustomerData() {
                return {
                    name: 'customerRoute',
                    params: {recordId: this.$route.params.recordId},
                    query: {editMode:'customerBasedata'},
                }
            },
            toOverview() {
                return {
                    name: 'overviewRoute',
                    params: {recordId: this.$route.params.recordId},
                }
            },
        },
        mounted() {
            recordRepository.getBasicData(this.$route.params.recordId).then(
                (data) => {
                    this.record = data.data;
                    this.customer = data.data.attributes.customer.data;
                    this.vehicle = data.data.attributes.vehicle.data;

                    setTimeout(() => {
                        if (this.isDebtCollectionClaim) {
                            this.$router.push(this.toRecordCustomerData);
                        } else if (this.isRegressClaim) {
                            this.$router.push(this.toOverview);
                        } else {
                            this.$router.push(this.toRecordAccidentData);
                        }

                        // We need the page reload, as we have separate components rendered by zend backend.
                        window.location.reload();
                    }, 3000)
                }
            );
        },
    }
</script>
